<template>
  <div>
    <div class="search-form">
      <div class="search-form-left">
        <div class="form">
          <a-form-model
            layout="inline"
            :model="form"
          >
            <a-form-model-item
              label="自然年度"
            >
              <a-select
                v-model="form.year"
                placeholder="请选择自然年度"
                allow-clear
                show-search
              >
                <a-select-option
                  v-for="item in yearsOptions"
                  :key="item.year"
                >
                  {{ item.year }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model>
        </div>

        <div class="ant-btns-mrright">
          <TableActions
            :actions="headerActions"
            @check="queryTotal"
          />
        </div>
      </div>

      <div class="m-totalAmount">
        <div class="m-total-desc">
          收入总额：
        </div>
        <div class="m-total-number">
          {{ nowYearAmounts[nowYearAmounts.length-1] }}
        </div>
        <div>
          同比
          <span
            v-if="growthRatioSamesCopy.length>0"
            class="m-total-ratio"
          >
            {{ Number(growthRatioSamesCopy[growthRatioSamesCopy.length-1])>=0 ? '增长（年）'+ Math.abs(growthRatioSamesCopy[growthRatioSamesCopy.length-1])+'%':'降低（年）'+ Math.abs(growthRatioSamesCopy[growthRatioSamesCopy.length-1])+'%' }}
          </span>
        </div>
      </div>
    </div>

    <div class="m-chart">
      <div
        id="mySamechart"
        class="mySamechart"
      />

      <div
        id="myRingChart"
        class="myRingChart"
      />
    </div>
  </div>
</template>

<script>
import { queryIncomeGrowthAnalysis } from '@/api/analyzer.js'

const headerActions = [
  {
    title: '查询',
    type: 'primary',
    action: 'check'
  }
]

export default {
  data () {
    return {
      headerActions,
      columns: [
        {
          title: '年度',
          dataIndex: 'year',
          key: 'year',
          width: '130px'
        }
      ],
      dataSource: [],
      loading: false,
      baseId: 0,
      baseOptions: [],
      productTypetions: [],
      modalVisible: false,
      confirmLoading: false,
      initData: null,
      dialogTitle: null,
      form: {
        year: undefined
      },
      seriesData: [{}, {}],
      xAxisData: [],
      sameLegendData: [],
      ringLegendData: [],
      yearsOptions: [],
      preYearAmounts: [],
      nowYearAmounts: [],
      growthRatioSames: [],
      growthRatioRings: [],
      growthRatioSamesCopy: [],
      growthRatioRingsCopy: []
    }
  },
  mounted () {
    this.loading = true
    this.fetchSearchOptions()
    this.queryTotal()
  },
  methods: {
    queryTotal () {
      this.dataSource = [{}, {}, {}]
      this.sameLegendData = []
      this.ringLegendData = []
      this.preYearAmounts = []
      this.nowYearAmounts = []
      this.xAxisData = []
      this.fetchData()
    },
    fetchSearchOptions () {
      for (let i = 2018; i <= new Date().getFullYear(); i++) {
        this.yearsOptions.unshift({ year: i, value: i })
      }
      this.form.year = new Date().getFullYear()
    },
    // 异步获取数据
    fetchData () {
      this.loading = true
      queryIncomeGrowthAnalysis({
        year: this.form.year
      }).then((data) => {
        this.dataSource = [{}, {}, {}]
        this.growthRatioRings = []
        this.growthRatioSames = []

        this.$set(this.dataSource[0],
          'year',
          data.preYear)

        this.$set(this.dataSource[1],
          'year',
          data.nowYear)

        this.$set(this.dataSource[2],
          'year',
          '同比增长率')

        this.sameLegendData = [String(data.preYear), String(data.nowYear), '同比增长率']
        this.ringLegendData = ['收入总额', '环比增长率']

        data.monthsData.map((item, index) => {
          this.columns.push({
            title: item.month,
            dataIndex: item.month,
            key: item + index
          })

          this.$set(this.dataSource[0],
            item.month,
            item.preYearAMount)

          this.$set(this.dataSource[1],
            item.month,
            item.nowYearAmount)

          this.$set(this.dataSource[2],
            item.month,
            item.growthRatioSame)

          this.preYearAmounts.push(item.preYearAmount)
          this.nowYearAmounts.push(item.nowYearAmount)
          this.growthRatioSames.push(item.growthRatioSame + '%')
          this.growthRatioRings.push(item.growthRatioRing + '%')

          this.growthRatioSamesCopy.push(item.growthRatioSame)
          this.growthRatioRingsCopy.push(item.growthRatioRing)
          this.xAxisData.push(item.month + '月')
        })

        this.preYearAmounts.push(data.preYearAmount)
        this.nowYearAmounts.push(data.nowYearAmount)
        this.growthRatioSames.push(data.yearGrowthRatio + '%')
        this.growthRatioRings.push(data.yearGrowthRing + '%')

        this.growthRatioSamesCopy.push(data.yearGrowthRatio)
        this.growthRatioRingsCopy.push(data.yearGrowthRing)
        this.initEcharts()
      }
      )
      this.loading = false
    },
    initEcharts () {
      const option1 = {
        title: {
          text: '同比增长',
          x: 'center', // x轴方向对齐方式
          top: 10 // 标题栏的高度，值越大，距离顶部的距离越大
        },
        darkMode: true,
        grid: {
          x: 150,
          // y:45,
          x2: 50,
          y2: 210
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          align: 'right',
          itemGap: 30,
          orient: 'vertical',
          textStyle: { color: '#000' },
          bottom: 60,
          left: 0,
          data: this.sameLegendData
        },
        xAxis: [
          {
            type: 'category',
            max: this.xAxisData.length,
            interval: Math.ceil(12) / 12,
            axisTick: {
              interval: 12 / 12
            },
            axisLabel: {
              fontWeight: 'bold',
              show: true,
              textStyle: {
                // color: "#f4f4f4",
                fontSize: '14px'
              }
            },
            data: [...this.xAxisData, '累计'],
            axisPointer: {
              type: 'shadow'
            },
            axisLine: {
              onZero: false // X 轴或者 Y 轴的轴线是否在另一个轴的 0 刻度上，只有在另一个轴为数值轴且包含 0 刻度时有效。
            }
          },
          {
            position: 'bottom', // 将分组x轴位置定至底部，不然默认在顶部
            offset: 45, // 向下偏移，使分组文字显示位置不与原x轴重叠
            axisTick: {
              length: -165, // 延长刻度线做分组线
              inside: true, // 使刻度线相对轴线在上面与原x轴相接，默认在轴线下方
              lineStyle: { color: '#000' } // 非必须，仅为了演示，明显标示出分组刻度线
            },
            // min: -30,
            max: this.xAxisData.length,
            // interval: 1,
            axisLabel: {
              inside: true, // 使刻度名称相对轴线在上面与原x轴相接，默认在轴线下方
              interval: 0 // 强制显示全部刻度名
            },
            data: ['']
          },
          {
            position: 'bottom', // 将分组x轴位置定至底部，不然默认在顶部
            offset: 36, // 向下偏移，使分组文字显示位置不与原x轴重叠
            max: this.xAxisData.length,
            // interval: Math.ceil(12) / 12,
            axisTick: {
              length: 0, // 延长刻度线做分组线
              inside: true, // 使刻度线相对轴线在上面与原x轴相接，默认在轴线下方
              lineStyle: { color: '#000' } // 非必须，仅为了演示，明显标示出分组刻度线
            },
            axisLabel: {
              inside: true, // 使刻度名称相对轴线在上面与原x轴相接，默认在轴线下方
              interval: 0 // 强制显示全部刻度名
            },
            axisLine: {
              onZero: false // X 轴或者 Y 轴的轴线是否在另一个轴的 0 刻度上，只有在另一个轴为数值轴且包含 0 刻度时有效。
            }
          },
          {
            position: 'bottom', // 将分组x轴位置定至底部，不然默认在顶部
            offset: 75, // 向下偏移，使分组文字显示位置不与原x轴重叠
            max: this.xAxisData.length,
            // interval: 1,
            axisTick: {
              length: 0, // 延长刻度线做分组线
              inside: true, // 使刻度线相对轴线在上面与原x轴相接，默认在轴线下方
              lineStyle: { color: '#000' } // 非必须，仅为了演示，明显标示出分组刻度线
            },
            axisLabel: {
              inside: true, // 使刻度名称相对轴线在上面与原x轴相接，默认在轴线下方
              interval: 0 // 强制显示全部刻度名
            },
            data: this.preYearAmounts,
            axisLine: {
              onZero: false // X 轴或者 Y 轴的轴线是否在另一个轴的 0 刻度上，只有在另一个轴为数值轴且包含 0 刻度时有效。
            }
          },
          {
            position: 'bottom', // 将分组x轴位置定至底部，不然默认在顶部
            offset: 120, // 向下偏移，使分组文字显示位置不与原x轴重叠
            max: this.xAxisData.length,
            // interval: 1,
            axisTick: {
              length: 0, // 延长刻度线做分组线
              inside: true, // 使刻度线相对轴线在上面与原x轴相接，默认在轴线下方
              lineStyle: { color: '#000' } // 非必须，仅为了演示，明显标示出分组刻度线
            },
            axisLabel: {
              inside: true, // 使刻度名称相对轴线在上面与原x轴相接，默认在轴线下方
              interval: 0 // 强制显示全部刻度名
            },
            data: this.nowYearAmounts,
            axisLine: {
              onZero: false // X 轴或者 Y 轴的轴线是否在另一个轴的 0 刻度上，只有在另一个轴为数值轴且包含 0 刻度时有效。
            }
          },
          {
            position: 'bottom', // 将分组x轴位置定至底部，不然默认在顶部
            offset: 160, // 向下偏移，使分组文字显示位置不与原x轴重叠
            max: this.xAxisData.length,
            // interval: 1,
            axisTick: {
              length: 0, // 延长刻度线做分组线
              inside: true, // 使刻度线相对轴线在上面与原x轴相接，默认在轴线下方
              lineStyle: { color: '#000' } // 非必须，仅为了演示，明显标示出分组刻度线
            },
            axisLabel: {
              inside: true, // 使刻度名称相对轴线在上面与原x轴相接，默认在轴线下方
              interval: 0 // 强制显示全部刻度名
            },
            data: this.growthRatioSames,
            axisLine: {
              onZero: false // X 轴或者 Y 轴的轴线是否在另一个轴的 0 刻度上，只有在另一个轴为数值轴且包含 0 刻度时有效。
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '元',
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}%'
            },
            splitLine: { show: false }
          }
        ],
        series: [
          {
            name: this.sameLegendData[0],
            type: 'bar',
            // unit: '吨',
            groupName: this.sameLegendData[0],
            data: this.preYearAmounts,
            itemStyle: {
              color: 'rgb(242, 143, 133)'
            },
            lineStyle: {
              width: 5
            },
            yAxisIndex: 0
          },
          {
            name: this.sameLegendData[1],
            type: 'bar',
            // unit: '吨',
            groupName: this.sameLegendData[1],
            data: this.nowYearAmounts,
            itemStyle: {
              color: 'rgb(183, 222, 232)'
            },
            lineStyle: {
              width: 5
            },
            yAxisIndex: 0
          },
          {
            name: this.sameLegendData[2],
            type: 'line',
            // unit: '吨',
            groupName: this.sameLegendData[1],
            data: this.growthRatioSamesCopy,
            yAxisIndex: 1,
            lineStyle: {
              width: 5
            },
            axisLine: {
              onZeroAxisIndex: 0
            }
          }
        ]
      }

      const option2 = {
        title: {
          text: '环比增长',
          x: 'center', // x轴方向对齐方式
          top: 10 // 标题栏的高度，值越大，距离顶部的距离越大
        },
        darkMode: true,
        grid: {
          x: 150,
          // y:45,
          x2: 50,
          y2: 125
          // borderWidth:1
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          align: 'right',
          itemGap: 30,
          orient: 'vertical',
          textStyle: { color: '#000' },
          bottom: 10,
          left: 0,
          data: this.ringLegendData
        },
        xAxis: [
          {
            type: 'category',
            max: this.xAxisData.length,
            interval: Math.ceil(12) / 12,
            axisTick: {
              interval: 12 / 12
            },
            axisLabel: {
              fontWeight: 'bold',
              show: true,
              textStyle: {
                // color: "#f4f4f4",
                fontSize: '14px'
              }
            },
            data: [...this.xAxisData, '累计'],
            axisPointer: {
              type: 'shadow'
            },
            axisLine: {
              onZero: false // X 轴或者 Y 轴的轴线是否在另一个轴的 0 刻度上，只有在另一个轴为数值轴且包含 0 刻度时有效。
            }
          },
          {
            position: 'bottom', // 将分组x轴位置定至底部，不然默认在顶部
            offset: 45, // 向下偏移，使分组文字显示位置不与原x轴重叠
            axisTick: {
              length: -165, // 延长刻度线做分组线
              inside: true, // 使刻度线相对轴线在上面与原x轴相接，默认在轴线下方
              lineStyle: { color: '#000' } // 非必须，仅为了演示，明显标示出分组刻度线
            },
            max: this.xAxisData.length,
            axisLabel: {
              inside: true, // 使刻度名称相对轴线在上面与原x轴相接，默认在轴线下方
              interval: 0 // 强制显示全部刻度名
            },
            data: ['']
            // axisLine: {
            //   onZero: false // X 轴或者 Y 轴的轴线是否在另一个轴的 0 刻度上，只有在另一个轴为数值轴且包含 0 刻度时有效。
            // }
          },
          {
            position: 'bottom', // 将分组x轴位置定至底部，不然默认在顶部
            offset: 36, // 向下偏移，使分组文字显示位置不与原x轴重叠
            max: this.xAxisData.length,
            interval: Math.ceil(12) / 12,
            axisTick: {
              length: 0, // 延长刻度线做分组线
              inside: true, // 使刻度线相对轴线在上面与原x轴相接，默认在轴线下方
              lineStyle: { color: '#000' } // 非必须，仅为了演示，明显标示出分组刻度线
            },
            axisLabel: {
              inside: true, // 使刻度名称相对轴线在上面与原x轴相接，默认在轴线下方
              interval: 0 // 强制显示全部刻度名
            },
            axisLine: {
              onZero: false // X 轴或者 Y 轴的轴线是否在另一个轴的 0 刻度上，只有在另一个轴为数值轴且包含 0 刻度时有效。
            }
          },
          {
            position: 'bottom', // 将分组x轴位置定至底部，不然默认在顶部
            offset: 75, // 向下偏移，使分组文字显示位置不与原x轴重叠
            max: this.xAxisData.length,
            interval: 1,
            axisTick: {
              length: 0, // 延长刻度线做分组线
              inside: true, // 使刻度线相对轴线在上面与原x轴相接，默认在轴线下方
              lineStyle: { color: '#000' } // 非必须，仅为了演示，明显标示出分组刻度线
            },
            axisLabel: {
              inside: true, // 使刻度名称相对轴线在上面与原x轴相接，默认在轴线下方
              interval: 0 // 强制显示全部刻度名
            },
            data: this.nowYearAmounts,
            axisLine: {
              onZero: false // X 轴或者 Y 轴的轴线是否在另一个轴的 0 刻度上，只有在另一个轴为数值轴且包含 0 刻度时有效。
            }
          },
          {
            position: 'bottom', // 将分组x轴位置定至底部，不然默认在顶部
            offset: 120, // 向下偏移，使分组文字显示位置不与原x轴重叠
            max: this.xAxisData.length,
            interval: 1,
            axisTick: {
              length: 0, // 延长刻度线做分组线
              inside: true, // 使刻度线相对轴线在上面与原x轴相接，默认在轴线下方
              lineStyle: { color: '#000' } // 非必须，仅为了演示，明显标示出分组刻度线
            },
            axisLabel: {
              inside: true, // 使刻度名称相对轴线在上面与原x轴相接，默认在轴线下方
              interval: 0 // 强制显示全部刻度名
            },
            data: this.growthRatioRings,
            axisLine: {
              onZero: false // X 轴或者 Y 轴的轴线是否在另一个轴的 0 刻度上，只有在另一个轴为数值轴且包含 0 刻度时有效。
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '元',
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}%'
            },
            splitLine: { show: false }
          }
        ],
        series: [
          {
            name: this.ringLegendData[0],
            type: 'bar',
            groupName: this.ringLegendData[0],
            data: this.nowYearAmounts,
            itemStyle: {
              color: 'rgb(242, 143, 133)'
            },
            lineStyle: {
              width: 5
            },
            yAxisIndex: 0
          },
          {
            name: this.ringLegendData[1],
            type: 'line',
            groupName: this.ringLegendData[1],
            data: this.growthRatioRingsCopy,
            itemStyle: {
              color: 'rgb(183, 222, 232)'
            },
            lineStyle: {
              width: 5
            },
            yAxisIndex: 1
          }
        ]
      }

      const mySamechart = this.$echarts.init(document.getElementById('mySamechart'))// 图标初始化
      const myRingChart = this.$echarts.init(document.getElementById('myRingChart'))// 图标初始化
      mySamechart.setOption(option1)// 渲染页面
      myRingChart.setOption(option2)
      // 随着屏幕大小调节图表
      window.addEventListener('resize', () => {
        mySamechart.resize()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 16px;
}

.search-form {
  // position: absolute;
  .m-totalAmount {
    width: 600px;
    // position: relative;
    // top:30px;
    // right:20px;
    font-size: 30px;
    font-weight: bold;
  }

  .m-total-number {
    color: #3360FF;
  }

  .m-total-ratio {
    color:#ff3333;
  }
}

.mySamechart {
  width: 100%;
  height: 400px;
}

.myRingChart {
  width: 100%;
  height: 400px;
  margin-top: 60px;
}

.m-total-desc {
  display: inline-block;
}

.m-total-number {
  display: inline-block;
}
</style>
